<div class="flex flex-col gap-6" *transloco="let t">
  <div class="flex flex-col gap-10 lg:flex-row">
    <div class="flex w-full flex-col gap-6 lg:w-[28rem] lg:shrink-0">
      <div class="flex flex-col gap-2">
        <h2 class="text-lg font-medium">{{ t("common.headline") | titlecase }}</h2>
        <IFormField>
          <div iInputGroup>
            <input
              iInputGroupInput
              size="sm"
              [placeholder]="t('dsp-strategy-page.enter_headline')"
              [formField]="headlineForm"
              (pressedEnter)="saveHeadline()"
            />
            <button
              iInputGroupSuffix
              iButton
              size="xs"
              [disabled]="headlineForm().invalid() || !headlineForm().dirty()"
              [loading]="isUpdatingHeadline()"
              (click)="saveHeadline()"
            >
              @if (!isUpdatingHeadline()) {
                <IIcon name="return" />
              }
              {{ t("common.save") }}
            </button>
          </div>
          <div class="text-xs text-gray-700">
            {{ t("sb-form-creative.headline_max_length", [headlineMaxLength()]) }}
          </div>
        </IFormField>
      </div>
      <div class="flex flex-col items-start">
        <h2 class="text-lg font-medium">{{ t("common.logo") | titlecase }}</h2>
        <div class="mt-4">
          <app-dsp-creative
            [assetId]="logoAssetId()"
            [addAssetLabel]="t('dsp-strategy-page.add_logo')"
            [mediaType]="MediaType.brandLogo"
            [isLoading]="isUpdatingLogo()"
            [framed]="true"
            (selectedAssetId)="saveLogoAsset($event)"
            (deleteAsset)="deleteLogoAsset()"
            (assetToUpload)="uploadLogo($event)"
          />
        </div>
      </div>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="text-lg font-medium">
        {{ t("common.preview") | titlecase }}
      </h2>
      <div class="mt-2 overflow-x-auto">
        <div
          class="grid h-[250px] w-[970px] grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,2fr)] grid-rows-2 rounded-sm border"
        >
          @if (logoAssetId()) {
            <div class="flex justify-center" [ngClass]="!headlineForm().value() ? 'row-span-2 p-2' : 'pt-2'">
              <app-dsp-creative
                [assetId]="logoAssetId()"
                [addAssetLabel]="t('dsp-strategy-page.add_logo')"
                [mediaType]="MediaType.brandLogo"
                [isLoading]="isUpdatingLogo()"
                [displayAssetName]="false"
                (selectedAssetId)="saveLogoAsset($event)"
                (deleteAsset)="deleteLogoAsset()"
                (assetToUpload)="uploadLogo($event)"
              />
            </div>
          }
          @if (headlineForm().value()) {
            <div
              class="col-start-1 flex min-w-0 items-center justify-center overflow-hidden px-2 text-center text-sm italic"
              [class.row-start-2]="logoAssetId()"
              [class.row-span-2]="!logoAssetId()"
            >
              <span class="line-clamp-4 w-full break-words">{{ headlineForm().value() }}</span>
            </div>
          }

          @let hasHeadlineOrLogo = logoAssetId() || headlineForm().value();
          <div
            class="row-span-2 row-start-1 flex justify-center p-1"
            [ngClass]="hasHeadlineOrLogo ? 'col-start-2' : 'col-span-2 col-start-1'"
          >
            <img
              class="h-full w-auto object-contain"
              [src]="firstProductInStrategy() | amazonProductImageUrl: 200"
              alt="Product preview"
            />
          </div>
          <div class="col-start-3 row-span-2 row-start-1 flex min-w-0 flex-col items-start justify-center gap-1 p-6">
            <div class="line-clamp-3 max-w-full font-medium">{{ firstProductInStrategy()?.title ?? "" }}</div>
            <div class="flex gap-1">
              <app-review-score [score]="4.5" [amazonStyle]="true" class="text-2xl" />
              <span class="font-medium text-gray-500">XXX</span>
            </div>
            @let price = firstProductInStrategy()?.price;
            <div class="flex pt-1">
              <div class="text-xs">{{ productCurrencySymbol() }}</div>
              @if (price !== undefined) {
                <div class="text-2xl font-medium">
                  {{ price | currency: productCurrency() : "" : undefined : locale() }}
                </div>
              } @else {
                <div class="text-2xl font-medium">XXX</div>
                <div class="text-xs">XX</div>
              }
            </div>
            <a
              class="rounded-full bg-[#ffa41c] px-4 py-1.5 text-sm"
              [href]="firstProductInStrategy() | amazonProductUrlPipe"
              target="_blank"
              rel="noopener noreferrer"
              >Shop now</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-4 flex gap-2">
    <IToggle
      [checked]="ecommerceCreativeMandatory()"
      [disabled]="isReadOnly()"
      (checkedChange)="toggleEcommerceCreativeMandatory($event)"
      [loading]="isUpdatingEcommerceCreativeMandatory()"
    />
    <div class="flex items-center gap-1 text-sm text-gray-800">
      {{ t("dsp-creatives.responsive_ecommerce_mandatory_toggle")
      }}<IIcon
        name="infoCircle"
        class="text-base"
        [iTooltip]="t('dsp-creatives.responsive_ecommerce_mandatory_description')"
      />
    </div>
  </div>
</div>
